export default __webpack_public_path__ + "static/media/duster-gallery-3.6f8aabfc.jpg";